export let queryCategory = "current=1&pageSize=10";
export let queryTopic = "current=1&pageSize=10";
